import React, { useState } from "react";
import { useNavigate, useParams } from "react-router";
import { NavBarThree } from "../components/Header";
import { FootBar } from "../components/Footer";

import { useQuery } from "@tanstack/react-query";
import { CollaboratorContainer } from "../components/Container";
import { RepositoryApi } from "../app/api/repository.api";
import { Form3 } from "../components/Form";


const repInstance = RepositoryApi();


export function Setting()
{
    
    const { repid } = useParams();
    const navigate = useNavigate();

    const [state, setState] = useState(false);
    const [response , setresponse] = useState(false);
    const [message , setmessage] = useState('');

// ********************************************************
    const findOneRepository = async () => {
        const {data} = await repInstance.findOne(repid);
        console.log(data)
        return data.data;
    };
             
    const { data } = useQuery({
        queryKey: ["one_repository"],
        queryFn: findOneRepository,
    });

// ********************************************************
    const removeRepository = ()=>{
        repInstance.delete(repid)
        .then( res => { 
            if( res.message === true ) navigate('/repertoires')
            else{  
                setmessage('Oops ! une erreur est survenue. Veuillez réessayer') 
                setresponse(true) 
            }})
        .catch( err => {
            setmessage('Erreur serveur interne. Veuillez réessayer') 
            setresponse(true)
        } )      
    }


    return(

        <div className="container-fluid">
            <div className="row">              
                {/* *************************************************************** */}
                <div className="col-lg-12 sticky-top bg-light border-bottom">  <NavBarThree target={'repository'} />  </div>    
                {/* ************************************************* */}
                <div className="col-md-12 bg-light sticky-top">  
                    <div className="row pt-5 d-flex justify-content-center">  
                        <div className="col-lg-10">  
                            <ul className="nav nav-tabs">
                                <li className="nav-item bg-ligh ">  <a className="nav-link color-gren active" aria-current="page" href="/repertoires"> Mes repertoires </a> </li>
                                <li className="nav-item">  <a className="nav-link text-muted" href="/repertoires-partages"> Partages </a> </li>
                                <li className="nav-item">  <a className="nav-link text-muted" href="/notifications"> Notifications </a> </li>
                            </ul>
                        </div>
                    </div>
                </div> 
                {/* ************************************************* */}
                <div className="col-lg-12 bg-white min-h-80">  
                    <div className="row">  
                        {/* ------------------------------------------------------------------------- */}
                        <div className="col-lg-7">  
                            <div className="row p-4"> 
                                <div className="col-lg-12 mb-4"> 
                                    <div className="d-flex flex-column py-3 mt-3 border bg-white rounded-2">
                                        <p className="font-lg text-muted px-4 border-bottom py-2"> Note d'information </p>
                                        <span className="text-secondary px-4 mb-1"> -  Voir la list des utilisateurs qui exploitent le répertoire partagé </span>
                                        <span className="text-secondary px-4 mb-1"> -  Partagé le <span className='color-orange' > lien de patager </span>, Pour faire un partage groupé de ce répertoire,  </span>
                                        <span className="text-secondary px-4 mb-1"> -  Modifier les informations de votre répertoire ou le supprimer </span>
                                    </div>
                                </div>
                            </div>
                            <div className="row bg-light pb-5 border-bottom"> 
                                {/* ----------------------------------------- */}
                                <div className="col-lg-12 bg-light border-top"> 
                                    <div className="d-flex flex-column p-4">
                                        <span className="small text-muted mb-1 ps-1"> Url de partage : </span> 
                                        <input type="link" value={ data?.shareLinks[0]?.token &&  'https://samadoc.xelkoomai.sn/' + data?.shareLinks[0]?.token } className="p-3 text-muted border rounded" />
                                    </div>
                                </div> 
                                {/* ----------------------------------------- */}
                                <div className="col-lg-12 bg-light border-top border-bottom"> 
                                    <div className="d-flex justify-content-between p-4">
                                        <span className="font-lg text-muted"> Collaborateurs </span> 
                                    </div>
                                </div> 
                                {/* ----------------------------------------- */}
                                <CollaboratorContainer repid={repid} data={ data?.sharedWith } />
                            </div> 
                        </div> 
                       {/* ------------------------------------------------------------------------- */}
                        <div className="col-lg-5 bg-light border-start px-0">  
                            <div className="d-flex justify-content-between py-3 border-bottom px-4">
                                <span className="font-lg text-muted"> Formulaire de modification </span> 
                            </div>
                            {/* +++++++++++++++++++++++++++++++++++++++++++++++++++ */}
                            <Form3 data={data} />
                            {/* +++++++++++++++++++++++++++++++++++++++++++++++++++ */}
                            <div className="d-flex justify-content-between align-items-center border-top border-bottom p-4">
                                <span className="font-md text-muted mb-2"> Suppression d'un répertoire : </span> 
                                <button className="btn btn-sm btn-orange-outline" onClick={ ()=> setState( !state ) }> { state ? 'Annuler la suppression' : 'Supprimer repertoire' } </button>
                            </div>
                            {/* +++++++++++++++++++++++++++++++++++++++++++++++++++ */}
                            {
                                state ?
                            (
                            <div className="p-4">
                                <div className="d-flex flex-column border rounded-2">
                                    <p className="font-md text-muted mb-2 py-2 px-3 border-bottom"> Etes vous vraiment sure de supprimer cette répertoire ? </p> 
                                    {
                                        response ? ( <div className="px-3 mb-4"> <span className="text-muted alert text-center alert-danger"> { message } </span> </div> ) : null
                                    }
                                    <div className="d-flex gap-3 px-3 py-2">
                                        <button className="btn btn-sm btn-orange" onClick={ removeRepository } > Oui </button>
                                        <button className="btn btn-sm btn-orange-outline"  onClick={ ()=> setState( false ) } > Non </button>
                                    </div>
                                </div>
                            </div>
                            ) : null 
                            }

                            {/* +++++++++++++++++++++++++++++++++++++++++++++++++++ */}
                        </div>  
                    </div>     
                </div> 
                {/* *************************************************************** */}
                <div className="col-lg-12 bg-dark">  <FootBar />  </div>
            </div>
        </div>  
    )
}


